'use client';

import { loadConnectAndInitialize } from '@stripe/connect-js';
import { ConnectComponentsProvider, ConnectNotificationBanner as StripeNotificationBanner } from '@stripe/react-connect-js';
import { useEffect, useMemo, useState } from 'react';
import { createConnectAccountSession, getConnectStatus } from './api';

export function ConnectNotificationBanner({ sellerUserId }: { sellerUserId: string }) {
  const [hasConnectAccount, setHasConnectAccount] = useState(false);
  const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY?.trim() ?? '';

  useEffect(() => {
    let active = true;
    void getConnectStatus(sellerUserId)
      .then((status) => {
        if (active) setHasConnectAccount(Boolean(status.stripeConnectAccountId));
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [sellerUserId]);

  const connectInstance = useMemo(() => {
    if (!publishableKey || !hasConnectAccount) return null;
    return loadConnectAndInitialize({
      publishableKey,
      fetchClientSecret: async () => {
        const session = await createConnectAccountSession(sellerUserId);
        return session.clientSecret;
      },
      appearance: {
        overlays: 'dialog',
      },
    });
  }, [hasConnectAccount, publishableKey, sellerUserId]);

  if (!connectInstance) return null;

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <StripeNotificationBanner />
    </ConnectComponentsProvider>
  );
}
